export enum LandDevelopmentStatus {
  FULL_MEDIA = 'FULL_MEDIA',
  PARTIAL_MEDIA = 'PARTIAL_MEDIA',
  NO_MEDIA = 'NO_MEDIA',
}

export enum LandDevelopmentStatusGermanString {
  FULL_MEDIA = 'Erschlossen',
  PARTIAL_MEDIA = 'Teilerschlossen',
  NO_MEDIA = 'Unerschlossen',
}
